import { request } from "../../utils/config"

const authHeader = () => ({
  Authorization: `Bearer ${localStorage.getItem("accessToken")}`,
})

export const GET_TASKS = async (params?: {
  status?: string
  managerId?: number
  begin?: string
  end?: string
  deadlineBegin?: string
  deadlineEnd?: string
  search?: string
  pageNumber?: number
  pageSize?: number
}) => {
  const response = await request({
    url: `Tasks`,
    method: "GET",
    params: {
      status: params?.status || "all",
      managerId: params?.managerId || undefined,
      begin: params?.begin || undefined,
      end: params?.end || undefined,
      deadlineBegin: params?.deadlineBegin || undefined,
      deadlineEnd: params?.deadlineEnd || undefined,
      search: params?.search || undefined,
      pageNumber: params?.pageNumber || 1,
      pageSize: params?.pageSize || 50,
    },
    headers: authHeader(),
  })
  return response.data
}

export const CREATE_TASK = async (data: {
  title: string
  description?: string
  assignedManagerId?: number
  assignedManagerName?: string
  /** Bir nechta menejerga biriktirish — har biriga alohida topshiriq yaratiladi */
  assignedManagerIds?: number[]
  dueDate?: string
  priority?: string
  status?: string
}) => {
  const response = await request({
    url: `Tasks`,
    method: "POST",
    data: data,
    headers: authHeader(),
  })
  return response.data
}

export const UPDATE_TASK = async (data: {
  id: number
  title?: string
  description?: string
  assignedManagerId?: number
  dueDate?: string
  priority?: string
  status?: string
}) => {
  const response = await request({
    url: `Tasks`,
    method: "PUT",
    data: data,
    headers: authHeader(),
  })
  return response.data
}

export const UPDATE_TASK_STATUS = async (data: {
  id: number
  status: string
  /** Bajarildi/bajarilmadi sababi — menejer izohi */
  managerComment?: string
  /** Bajarilgan ish haqida hisobot matni */
  reportText?: string
  /** Sabab toifasi: client_refused, no_time, technical, other */
  failureCategory?: string
  /** Qisman bajarilganmi */
  isPartial?: boolean
  attachmentUrl?: string
}) => {
  const response = await request({
    url: `Tasks/UpdateStatus`,
    method: "PUT",
    data: data,
    headers: authHeader(),
  })
  return response.data
}

/** Admin menejer hisobotini tasdiqlaydi yoki qayta ishlashga qaytaradi */
export const REVIEW_TASK = async (data: {
  id: number
  approve: boolean
  reviewComment?: string
}) => {
  const response = await request({
    url: `Tasks/Review`,
    method: "POST",
    data: data,
    headers: authHeader(),
  })
  return response.data
}

/** Menejer topshiriqni ochib ko'rdi — "O'qidim" tasdig'i */
export const MARK_TASK_READ = async (id: number) => {
  const response = await request({
    url: `Tasks/MarkRead`,
    method: "POST",
    data: { id },
    headers: authHeader(),
  })
  return response.data
}

export const DELETE_TASK = async (id: number) => {
  const response = await request({
    url: `Tasks/${id}`,
    method: "DELETE",
    headers: authHeader(),
  })
  return response.data
}
